// extracted by mini-css-extract-plugin
export var blue = "_1r-g";
export var brand = "_1r-c";
export var darkGrey = "_1r-f";
export var disabled = "_1r-6";
export var disabledSubtle = "_1r-7";
export var error = "_1r-8";
export var green = "_1r-h";
export var grey = "_1r-e";
export var icon = "_1r-0";
export var inherit = "_1r-b";
export var lightGrey = "_1r-d";
export var orange = "_1r-j";
export var pink = "_1r-l";
export var primary = "_1r-1";
export var purple = "_1r-m";
export var quaternary = "_1r-4";
export var quinary = "_1r-5";
export var red = "_1r-k";
export var secondary = "_1r-2";
export var success = "_1r-a";
export var tertiary = "_1r-3";
export var warning = "_1r-9";
export var white = "_1r-n";
export var yellow = "_1r-i";